import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './cons-beneficiary-document-type.reducer';
import { IConsBeneficiaryDocumentType } from 'app/shared/model/cons-beneficiary-document-type.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsBeneficiaryDocumentType = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const consBeneficiaryDocumentTypeList = useAppSelector(state => state.consBeneficiaryDocumentType.entities);
  const loading = useAppSelector(state => state.consBeneficiaryDocumentType.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="cons-beneficiary-document-type-heading" data-cy="ConsBeneficiaryDocumentTypeHeading">
        <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.home.title">Cons Beneficiary Document Types</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.home.createLabel">
              Create new Cons Beneficiary Document Type
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {consBeneficiaryDocumentTypeList && consBeneficiaryDocumentTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.actionStatus.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.actionStatus.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.folderName">Folder Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {consBeneficiaryDocumentTypeList.map((consBeneficiaryDocumentType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${consBeneficiaryDocumentType.id}`} color="link" size="sm">
                      {consBeneficiaryDocumentType.id}
                    </Button>
                  </td>
                  <td>{consBeneficiaryDocumentType.code}</td>
                  <td>{consBeneficiaryDocumentType.name}</td>
                  <td>{consBeneficiaryDocumentType.nameAr}</td>
                  <td>{consBeneficiaryDocumentType.nameEn}</td>
                  <td>{consBeneficiaryDocumentType.folderName}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${consBeneficiaryDocumentType.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${consBeneficiaryDocumentType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consBeneficiaryDocumentType.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consBeneficiaryDocumentType.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.consBeneficiaryDocumentType.home.notFound">
                No Cons Beneficiary Document Types found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ConsBeneficiaryDocumentType;
